import { css, styled } from '../../../theme';
import { scaleIn, scaleOut } from '../../../_core/animations/scale';

export const Center = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 120px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;

    ${theme.tokens.media.down('desktop')} {
      position: static;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  `}
`;

export const AnimatedScale = styled.div<{ $closing: boolean }>`
  ${({ theme, $closing }) => css`
    position: relative;
    margin-bottom: 120px;
    pointer-events: auto;
    animation-name: ${$closing ? scaleOut : scaleIn};
    animation-duration: ${theme.tokens.animation.duration.base};
    animation-timing-function: ease;
    animation-fill-mode: forwards;

    ${theme.tokens.media.down('desktop')} {
      width: 100%;
      flex: 1;
      margin-bottom: 0;
    }
  `}
`;
